"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreemshotEngine = void 0;
const logger_1 = require("../../../util/logger");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const clamp_if_streemshot_request_was_fulfilled_1 = require("../../../util/rx/clamp_if_streemshot_request_was_fulfilled");
class StreemshotEngine {
    constructor() {
        this.convertCanvasToBlob = (canvas) => {
            return new Promise((res, rej) => canvas.toBlob(blob => blob
                ? res(blob)
                : // eslint-disable-next-line prefer-promise-reject-errors
                    rej('Failed to create blob from canvas because blob is null'), 'image/jpeg', 0.7));
        };
    }
    /**
     * `fulfillStreemshotRequestsForWeb` returns an observable that will return a blob of image data and its streemshot request
     * @param opts FulfillStreemshotOpts
     */
    fulfillStreemshotRequestsForWeb(opts) {
        return opts.latestStreemshotRequest.pipe((0, operators_1.distinctUntilKeyChanged)('id'), (0, clamp_if_streemshot_request_was_fulfilled_1.clampIfStreemshotRequestWasFulfilled)(opts.streemshots), (0, operators_1.mergeMap)(latestRequest => this.mergeBlobAndLatestRequest(opts.canvas, latestRequest)));
    }
    mergeBlobAndLatestRequest(canvas, request) {
        return (0, rxjs_1.from)(this.convertCanvasToBlob(canvas)).pipe((0, operators_1.map)((blob) => [request, blob]), (0, operators_1.catchError)(err => {
            logger_1.logger.error('Cannot take streemshot on web: ', err);
            return rxjs_1.EMPTY;
        }));
    }
}
exports.StreemshotEngine = StreemshotEngine;
//# sourceMappingURL=streemshot_engine.js.map